import { isValidPhoneNumber } from 'libphonenumber-js';

/**
 * True if `full` (a full E.164 string like "+972541234567") is a valid number for its country code.
 * Mirrors the native `PhoneValidation` helpers (iOS/Android) — every surface validates the full E.164
 * string, so the country code the user selected is respected.
 */
export function isValidPhone(full: string): boolean {
  try {
    return isValidPhoneNumber(full);
  } catch {
    return false;
  }
}
